import React from 'react';
import LoggedoutView from '@xingternal/xing-view/LoggedoutView'; // eslint-disable-lines
import { Grid, Row, GridContainer } from '@xingternal/xing-grid';
import { useLocation } from 'react-router-dom';
import { useConfig } from '@xingternal/hops';

type LoggedOutAppProps = {
  children?: React.ReactNode;
};
const LoggedOutApp: React.FC<LoggedOutAppProps> = ({ children }) => {
  const { pathname = '', search = '', hash = '' } = useLocation();
  const { externalLoginUrl } = useConfig();

  const loginLink = `${externalLoginUrl}/?dest_url=${pathname}${search}${hash}`;

  return (
    <LoggedoutView
      loginLink={loginLink}
      // signup link redirects to login like all other apps (for consistency)
      signupLink={loginLink}
    >
      <GridContainer type="standard">
        <Grid>
          <Row>{children}</Row>
        </Grid>
      </GridContainer>
    </LoggedoutView>
  );
};

export default LoggedOutApp;
